import { getCheckOptionBody } from '@/api/trade-capture/option/request.ts';
import type { CheckOptionResponse } from '@/api/trade-capture/option/response.model.ts';
import { mapTcResponse, type OptionTcResponse } from '@/api/trade-capture/option/response.ts';
import type { WebapiEndpointBuilder } from '@/api/webapi.ts';
import type {
  FxOption,
  LegId,
  OptionHedge,
  OptionLegProperties,
  OptionProductName,
  OptionProperties,
  OptionTradeCapture,
} from '@/store/option/state.ts';

export type Nullable<T> = {
  [P in keyof T]: T[P] | null;
};

export type NullableLegProperties = Partial<Nullable<OptionLegProperties>> & { legId: LegId };
export type NullableOptionProperties = Partial<Nullable<Omit<OptionProperties, 'hedges' | 'legs'>>>;
export type NullableHedges = Partial<Nullable<OptionHedge>> & { legId: string };

export interface CheckOptionParams {
  tileId: string;
  productName: OptionProductName;
  properties?: NullableOptionProperties;
  legProperties?: NullableLegProperties[];
  hedges?: NullableHedges[];

  tradeCapture: OptionTradeCapture;
  optionState?: FxOption;
}

export const checkOption = (builder: WebapiEndpointBuilder) => {
  return builder.mutation<OptionTcResponse, CheckOptionParams>({
    query: (params) => ({
      url: '/tradeCaptureBatch/FxOptionMultileg',
      method: 'POST',
      body: getCheckOptionBody(params),
    }),
    transformResponse(response: CheckOptionResponse, _meta, params) {
      const tileId = params.tileId;
      const option = params.optionState;
      return mapTcResponse(response, tileId, params.tradeCapture.sessionId, option);
    },
  });
};
